define('views/modules/calendar/animated-session/exercise/lists/print/print-exercise-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent
    'views/modules/calendar/animated-session/exercise/lists/exercise-list',
    // views
    'views/modules/calendar/animated-session/exercise/lists/print/print-exercise-list-item',
    'views/modules/calendar/animated-session/exercise/lists/print/print-exercise-separator'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VExerciseList,
    VPrintExerciseListItem,
    VPrintExerciseSeparator
) {

    var VPrintExerciseList = VExerciseList.extend({
        exerciseView: VPrintExerciseListItem,
        sortable: false,

        addAllExercise: function(models) {
            if (!this.zone) return;

            var collection = models || this.collection.toArray();

            var delay = 50,
                count = 1,
                chunkSize = this.defaults.chunkSize,
                container = document.createDocumentFragment();

            container.id = "elementsContainer";

            this.elementsView = [];

            _.each(collection, function(model) {
                var elementView = this.addExercise(model, delay * count, false);
                this.elementsView.push(elementView.cid);

                var exercise = elementView.el;

                if (count % 3 === 0) {
                    exercise.children[1].className = exercise.className.concat(" hide");
                }
                container.appendChild(exercise);

                // Clear float every 3 items (new line)
                if (count % 3 === 0) {
                    if (count !== this.collection.length) {
                        container.appendChild(this.addSeparator(model, false).el);
                    }

                    var clearfix = document.createElement('div');
                    clearfix.className = "clearfix";
                    container.appendChild(clearfix);

                    var pageBreak = document.createElement('div');
                    pageBreak.id = "pagebreak-" + elementView.cid;
                    container.appendChild(pageBreak);
                }
                count++;
            }, this);

            this.append(container);

            var context = this;
            _.delay(_.bind(context.addPageBreak, context), 500);

            this.scrollToLast();

            this.onAddedAllExercise();
        },

        addSeparator: function(model, render) {
            var view = new VPrintExerciseSeparator({
                model: model,
                role: this.role
            });

            this.childViews.push(view);
            view.render();

            if (render !== false) this.append(view.el);
            return view;
        },

        addPageBreak: function() {
            var count = 1,
                lineHeight = 0,
                pageHeight = 225,
                continue_to_next_line = false,
                context = this,
                pagebreak_id = ""; // Start with first page header height

            _.each(this.elementsView, function(element) {
                var itemHeight = this.$("#exercise-item-" + element).height();

                if (itemHeight > lineHeight) {
                    lineHeight = itemHeight;
                }

                if (count % 3 === 0 || count === context.elementsView.length) {
                    pageHeight = pageHeight + lineHeight;

                    if (pageHeight > 875) {
                        this.$(pagebreak_id)[0].className = "html2pdf__page-break";
                        pageHeight = lineHeight;
                    }

                    lineHeight = 0;
                    pagebreak_id = "#pagebreak-" + element;
                }

                count++;
            });
        },

    });


    return VPrintExerciseList;

});

